// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actions {
    position:absolute;
    top:0;
    right:0;
    display:flex;
    flex-direction:row;
    background:black;
    color:white;
}
.editor-wrapper{
    display:block;
    position:relative;
    height:100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/imageeditor/imageeditor.control.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,KAAK;IACL,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf","sourcesContent":[".actions {\n    position:absolute;\n    top:0;\n    right:0;\n    display:flex;\n    flex-direction:row;\n    background:black;\n    color:white;\n}\n.editor-wrapper{\n    display:block;\n    position:relative;\n    height:100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
